import React, { Component } from 'react';
import TableWidget from "../../widgets/TableWidget";
import { withRouter } from 'react-router';


class AccountTimesheetDisplay extends Component {
    static displayName = AccountTimesheetDisplay.name;

    constructor(props) {
        super(props);

        this.state = Object.assign({}, props.options);
    

        this.handleEditTimesheet = this.handleEditTimesheet.bind(this);
        this.handleCertifyTimesheet = this.handleCertifyTimesheet.bind(this);

        this.formatAccountData = this.formatAccountData.bind(this);

        this.displayCertifiedBadge = this.displayCertifiedBadge.bind(this);
        this.displayEdit = this.displayEdit.bind(this);
    }

    async handleCertifyTimesheet(event) {
        if (window.confirm("Are you sure you'd like to certify this timesheet?")) {
            const timesheet = this.props.store.timesheets.getById(event.target.value);
            
            timesheet.isCertified = true;

            await timesheet.save(this.props.store);

            await this.props.store.getFromApi()
        }
    }

    handleEditTimesheet(event) {
        this.props.history.push("/staff/Timesheet/" + event.target.value);
    }

    displayCertifiedBadge(timesheetId) {
        let timesheet = this.props.store.timesheets.getById(timesheetId);

        if (timesheet.isCertified) {
            return (
                <span className="badge badge-secondary"
                    style= {{
                        textAlign: "center"
                    }}>{timesheet.dateCertifiedObject.format("MM/DD/YY h:mm a")}</span>
            )
        }
        else {
            return (
                <span className="badge badge-secondary"
                    style= {{
                        textAlign: "center",
                        backgroundColor: "#F2100C"
                    }}>Uncertified</span>            
            )
        }
    }

    displaySubmittedBadge(timesheetId) {
        let timesheet = this.props.store.timesheets.getById(timesheetId);

        if (timesheet.isFinal) {
            return (
                <span className="badge badge-secondary"
                    style= {{
                        textAlign: "center"
                    }}>{timesheet.dateSubmittedObject.format("MM/DD/YY h:mm a")}</span>
            )
        }
        else {
            return (
                <span className="badge badge-secondary"
                    style= {{
                        textAlign: "center",
                        backgroundColor: "#F2100C"
                    }}>Unsubmitted</span>            
            )
        }
    }


  /*displayLogSelectAll() {
        if (this.props.allTimesheetsSelected) {
            return (
                <button 
                    className="btn btn-dark"
                    type="button"
                    onClick={this.props.handleSelectAllTimesheets} 
                >Remove Logged</button>
            )
        }
        return (
            <button 
                className="btn btn-light"
                type="button"
                onClick={this.props.handleSelectAllTimesheets} 
            >Log All</button>
        )
    }*/

    displayEdit(timesheetId) {
        let timesheet = this.props.store.timesheets.getById(timesheetId);

        return (
            timesheet.isCertified ?
                (<button className="btn btn-light btn-sm" 
                    value={timesheetId} onClick={this.handleEditTimesheet}>
                        View
                </button>) :
                (<button className="btn btn-light btn-sm" 
                    value={timesheetId} onClick={this.handleEditTimesheet}>
                        Edit
                </button>)   
        )
    }


    createHeadings() {
        let i = 1;
        const headings = []

        if (this.state.showEdit) {
            headings.push(
                {
                    Header: "", accessor: "col" + i++,
                    Cell: (props) => this.displayEdit(props.cell.value),
                    props: {
                        colSpan: "1", style: { width: "10%", borderBottom: "3px solid white" }
                    }
                }
            )
        }

        if (this.state.showLoggedToggle) {
            headings.push(
                {
                    Header: "", accessor: "col" + i++,
                    Cell: (props) => this.props.displayLogCheckbox(props.cell.value),
                    props: {
                        colSpan: "1", style: { width: "10%", borderBottom: "3px solid white" }
                    }
                }
            )
        }

        if (this.state.showCertify) {
            headings.push(
                {
                    Header: "", accessor: "col" + i++,
                        Cell: (props) => ( this.props.displayCertify(props.cell.value)),
                        props: { colSpan: "1", style: { width: "10%", borderBottom: "3px solid white" }
                    }
                }
            )
        }

        this.state.showStudentName && headings.push(
            { Header: "Name", accessor: "col" + i++, props: { colSpan: "1", style: { width: "15%" } } },
        );
    

        this.state.showEmployerName && headings.push(
            { Header: "Employer Name", accessor: "col" + i++, props: { colSpan: "1", style: { width: "15%" } } },
        );

        this.state.showFopal && headings.push(
            { Header: "Fopal", accessor: "col" + i++, props: { colSpan: "1", style: { width: "15%" } } },
        );

        this.state.showTotalHours && headings.push(
            { Header: "Hours", accessor: "col" + i++, props: { colSpan: "1", style: { width: "15%" } } },
        );

        this.state.showSubmittedDate && headings.push(
            { Header: "Submitted", 
            Cell: (props) => this.displaySubmittedBadge(props.cell.value),
            accessor: "col" + i++, 
            props: { colSpan: "1", style: { width: "15%", textAlign:"center" } } },
        );

        this.state.showCertifiedDate && headings.push(
            { 
                Header: "Certified", accessor: "col" + i++, 
                Cell: (props) => this.displayCertifiedBadge(props.cell.value),
                props: { colSpan: "1", style: { width: "15%", textAlign:"center" } } 
            },
        );

        this.state.showWeekEndDate && headings.push(
            { Header: "Pay Period End Date", accessor: "col" + i++, props: { colSpan: "1", style: { width: "15%" } } },
        );

        if (this.state.showTimestampRange) {
            headings.push(
                { Header: "Sat", accessor: "col" + i++, props: { colSpan: "1", style: { width: "15%" } } },
            );
            headings.push(
                { Header: "Sun", accessor: "col" + i++, props: { colSpan: "1", style: { width: "15%" } } },
            );
            headings.push(
                { Header: "Mon", accessor: "col" + i++, props: { colSpan: "1", style: { width: "15%" } } },
            );
            headings.push(
                { Header: "Tue", accessor: "col" + i++, props: { colSpan: "1", style: { width: "15%" } } },
            );
            headings.push(
                { Header: "Wed", accessor: "col" + i++, props: { colSpan: "1", style: { width: "15%" } } },
            );
            headings.push(
                { Header: "Thu", accessor: "col" + i++, props: { colSpan: "1", style: { width: "15%" } } },
            );
            headings.push(
                { Header: "Fri", accessor: "col" + i++, props: { colSpan: "1", style: { width: "15%" } } },
            );
        }

        this.state.showWeekPay && headings.push(
            { Header: "Week Pay", accessor: "col" + i++, props: { colSpan: "1", style: { width: "15%" } } },
        );

        this.state.showBalance && headings.push(
            { Header: "Balance At Date", accessor: "col" + i++, props: { colSpan: "1", style: { width: "15%" } } },
        );

        return headings;
    }

    formatAccountData(accounts) {
        let formattedData = []

        for(let i = 0; i < accounts.length; i++) {
            let account = accounts[i];
            account.include(["student", "employer", "supervisor"])
            
            account.timesheets.map((timesheet) => {
                let colNum = 1
                let retval = {}

                this.state.showEdit && (retval["col" + colNum++] = timesheet.id);

                this.state.showLoggedToggle && (retval["col" + colNum++] = timesheet.id);

                this.state.showCertify && (retval["col" + colNum++] = timesheet.id);

                this.state.showStudentName && (retval["col" + colNum++] = account.student.name);
                
                this.state.showEmployerName && (retval["col" + colNum++] = account.employer.name);
                
                this.state.showFopal && (retval["col" + colNum++] = account.fopal);

                this.state.showTotalHours && (retval["col" + colNum++] = timesheet.totalHours);

                this.state.showSubmittedDate && (retval["col" + colNum++] = timesheet.id);
                this.state.showCertifiedDate && (retval["col" + colNum++] = timesheet.id);

                this.state.showWeekEndDate && (retval["col" + colNum++] = timesheet.weekEndDateObject.format("l"));

                //Get timestamp times
                if(this.state.showTimestampRange) {
                    retval["col" + colNum++] = this.props.store.timestamps.getById(timesheet.timestampIds[0]).totalTime
                    retval["col" + colNum++] = this.props.store.timestamps.getById(timesheet.timestampIds[1]).totalTime
                    retval["col" + colNum++] = this.props.store.timestamps.getById(timesheet.timestampIds[2]).totalTime
                    retval["col" + colNum++] = this.props.store.timestamps.getById(timesheet.timestampIds[3]).totalTime
                    retval["col" + colNum++] = this.props.store.timestamps.getById(timesheet.timestampIds[4]).totalTime
                    retval["col" + colNum++] = this.props.store.timestamps.getById(timesheet.timestampIds[5]).totalTime
                    retval["col" + colNum++] = this.props.store.timestamps.getById(timesheet.timestampIds[6]).totalTime
                }

                this.state.showWeekPay && (retval["col" + colNum++] = "$" + timesheet.totalPay.toFixed(2));
                this.state.showBalance && (retval["col" + colNum++] = "$" + timesheet.balanceAtDate.toFixed(2));
            
                formattedData.push(retval);

            });

        };

        return formattedData;
    }

    render () {

        const accounts = this.props.store.accounts.collection.filter(account => this.props.accountIds.includes(account.id));
        
        //Sort accounts by student name
        accounts.sort((a,b) => {
            a = a.include(["student"])
            b = b.include(["student"])
    
            if(a.student.lastName.toLowerCase() > b.student.lastName.toLowerCase()) {
                return 1;
            }
            else if(b.student.lastName.toLowerCase() > a.student.lastName.toLowerCase()) {
                return -1;
            }
            else {
                if(a.student.firstName.toLowerCase() > a.student.firstName.toLowerCase()) {
                    return 1;
                }
                else if(b.student.firstName.toLowerCase() > a.student.firstName.toLowerCase()) {
                    return -1;
                }
                return 0
            }
        });

        let headings = this.createHeadings();
        let data = this.formatAccountData(accounts);

        return (
            <TableWidget 
                columns={headings}
                data={data}
                {...this.props} 
            />
    )}
}


export default withRouter(AccountTimesheetDisplay);